import { Box } from '@material-ui/core';
import { Currency, formatMoney } from '@nemuru-eng/js-api-client';

import { Font } from '../../../shared/components/Font';
import { Text } from '../../../shared/components/Text';

interface FunnelSectionHeaderProps {
  titleTId: string;
  length?: number;
  totalAmount?: number;
  currency: Currency;
}

export const FunnelSectionHeader = ({ titleTId, length = 0, totalAmount = 0, currency }: FunnelSectionHeaderProps) => {
  return (
    <>
      <Box mb={2}>
        <Font variant={'h3'} color={'title'}>
          <Text tId={titleTId} />
        </Font>
      </Box>
      <Box display="flex" gridGap={'24px'}>
        <Box display={'flex'} flexDirection={'column'}>
          <Font variant={'overline'} color="title">
            <Text tId={'TOTAL_NUMBER'} />
          </Font>
          <Font variant={'h2'} color="title">
            {length}
          </Font>
        </Box>
        <Box display={'flex'} flexDirection={'column'}>
          <Font variant={'overline'} color="title">
            <Text tId={'TOTAL_AMOUNT'} />
          </Font>
          <Font variant={'h2'} color="title">
            {formatMoney(
              {
                value: totalAmount,
                currency,
              },
              0,
            )}
          </Font>
        </Box>
      </Box>
    </>
  );
};
